<template>
    <LeftSidebar :dark=true :open="dvAdminSidebarOpen" :width="600" :updateSidebar="updatedvAdminSidebar"
        :loading = "isLoading"       
        :lowerTitle="true"
        :right="true"
        style="z-index: 31 !important"  >
        
        <div slot="sbTitle">
            Admin Menu
        </div> 

        <div slot="sbContent" class="caption">
            <v-layout class="pt-2" column fill-height >  
                <v-flex>
                    <v-list class="pt-4">
                        <v-list-tile @click="goToMap()" >
                            <v-list-tile-action>
                                <v-icon >map</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title class="adminlistitem">Map</v-list-tile-title>
                            </v-list-tile-content>           
                        </v-list-tile>

                        <v-list-tile class="autoCompleteTile pb-0" :to="`/bldgviewer/`" exact @click="selectedddChoice = null">
                            <v-list-tile-action>
                                <v-icon>line_style</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-flex>
                                    <v-autocomplete
                                        v-model="selectedddChoice"
                                        :items="ddChoices"
                                        class=""
                                        flat solo
                                        hide-details   
                                        label="Edit Dropdown Lists"   
                                        @change="filterItems"                      
                                    ></v-autocomplete>
                                </v-flex>
                            </v-list-tile-content>           
                        </v-list-tile>


                        <ddEditor v-if="selectedddChoice" class="ml-5 mr-5"
                            v-on:reset="reset"
                             v-on:updateLoading="(value) => { isLoading=value }"
                            :items="itemArray" 
                            :title="selectedddChoice"/>               
                        
                    </v-list>
                </v-flex>
            </v-layout>    
        </div>
    </LeftSidebar>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex'
    import ddEditor from './ddEditor'
    import LeftSidebar from '@/components/LeftSidebar'
    
    //import DdEditor from '@/components/forms/bldgviewer/ddEditor.vue'

    let dvAdminSidebar = {

        

        data() {
          return {
            dialogOpen: false,
            ddChoices: [ 'Use Codes', 'Type Codes', 'Program Codes', 'Categories', 'Super Categories', 'Ownership', 'Plan Areas', 'Classifications' ],
            selectedddChoice: null,
            itemArray: [],
            isLoading: false,
          }
        },

        computed: {
            ...mapState({
                dvAdminSidebarOpen: state => state.ui.dvAdminSidebarOpen,
                uses: state => state.lists.uses,
                types: state => state.lists.types, 
                programs: state => state.lists.programs,
                categories: state => state.lists.categories,
                superCategories: state => state.lists.superCategories,
                ownership: state => state.lists.buildingOwnership,
                planAreas: state => state.lists.buildingPlanAreas,
                classifications: state => state.lists.classifications,
                darkTheme: state => state.ui.darkTheme,
                
            }),

            filterItems: function () {
                this.itemArray = []
                if          (this.selectedddChoice == "Use Codes") {
                                this.uses.forEach((use) => {
                                    let item = {}
                                    item.id = use.useID 
                                    item.name = use.useName
                                    this.itemArray.push(item)
                                })
                                
                } else if   (this.selectedddChoice == "Type Codes") {
                                this.types.forEach((type) => {
                                    let item = {}
                                    item.id = type.typeID 
                                    item.name = type.typeName
                                    item.super = type.categoryID
                                    //console.log(item)
                                    this.itemArray.push(item)
                                })
                                
                } else if   (this.selectedddChoice == "Program Codes") {
                                this.programs.forEach((program) => {
                                    let item = {}
                                    item.id = program.programID 
                                    item.name = program.programName
                                    this.itemArray.push(item)
                                })
                                
                } else if   (this.selectedddChoice == "Ownership") {
                                this.ownership.forEach((ownership) => {
                                    let item = {}
                                    item.id = ownership.ownershipCode 
                                    item.name = ownership.ownershipNameLong
                                    this.itemArray.push(item)
                                })
                                
                } else if   (this.selectedddChoice == "Plan Areas") {
                                this.planAreas.forEach((planArea) => {
                                    let item = {}
                                    item.id = planArea.planAreaCodeID 
                                    item.name = planArea.planAreaCodeName
                                    this.itemArray.push(item)
                                })
                } else if   (this.selectedddChoice == "Super Categories") {
                                this.superCategories.forEach((superCategory) => {
                                    let item = {}
                                    item.id = superCategory.superCategoryID
                                    item.name = superCategory.superCategoryName
                                    this.itemArray.push(item)
                                })

                } else if   (this.selectedddChoice == "Categories") {
                                this.categories.forEach((category) => {
                                    let item = {}
                                    item.id = category.categoryID 
                                    item.name = category.categoryName
                                    item.super = category.superCatID
                                    this.itemArray.push(item)
                                })
                                
                } else if   (this.selectedddChoice == "Classifications") {
                                this.classifications.forEach((classification) => {
                                    let item = {}
                                    item.id = classification.classificationKey 
                                    item.name = classification.classificationName
                                    this.itemArray.push(item)
                                })
                                
                }  
                return this.itemArray


            }

        },

        components: { ddEditor, LeftSidebar },

        methods: {
            ...mapMutations([   'updatedvAdminSidebar',                            ]),   

            goToMap: function ()    {
                this.updatedvAdminSidebar(false)
                this.$router.push('/')
            },

            reset: function () {
                this.selectedddChoice = null
            },



        }
    }

    export default dvAdminSidebar
</script>

<style>

.adminDVSidebar {
    height: 100%;    
    z-index: 30 !important;
    overflow: hidden !important; 
}

.autoCompleteTile .v-list__tile__content {

}

.autoCompleteTile .v-input__slot {
background: transparent !important;
padding: 0 !important;
}


</style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/dvAdminMenu.vue